import { TimeFrameTypes } from "./enums";

export interface NavFilterItem {
  type: TimeFrameTypes;
  label: string;
  active?: boolean;
}

export interface DashboardDataAvailabilityDto {
  hasClientActivity: boolean;
  hasKpiActivities: boolean;
  hasDashboardData: boolean;
}
